/* CustomerPrivacySecurityTabContent.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._zulp1k7u{gap:3.5rem}";
const _7 = "._otyrhiv4{margin-bottom:var(--ds-space-400)}";
const _6 = "._19pkhiv4{margin-top:var(--ds-space-400)}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { AtlassianProductHostingType } from '@atlassian/mpac-types';
import React from 'react';
import { CustomerPrivacySecurityContextProvider } from '../../context/CustomerPrivacySecurityContextProvider';
import { PrivacySecurityConfigV2 } from '../../PrivacySecurityConfigV2';
import { getContactPartnerUrl } from '../../utils';
import { getQnAV2 } from '../../utils/getQnAV2';
import { Certification } from '../Certification';
import { FeedbackCollectorWrapper } from '../FeedbackCollectorWrapper';
import { QnASection } from '../QnASection';
import { TabHeader } from '../TabHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._1tkebejm{min-height:31.25rem}";
const _2 = "._1yt41hdg{padding:var(--ds-space-400,2pc) 0 var(--ds-space-800,64x) 0}";
const _ = "._1bsb1osq{width:100%}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1yt41hdg _1tkebejm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const QnASectionWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _19pkhiv4 _otyrhiv4 _zulp1k7u", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  QnASectionWrapper.displayName = 'QnASectionWrapper';
}
export const CustomerPrivacySecurityTabContent = props => {
  var _partner$name, _partner$url;
  const {
    isEmptyState,
    appName,
    transformedAppTrustData,
    feedbackCollectorApiKeys,
    feedbackGatewayBaseUrl,
    userId
  } = props;
  const {
    enableRunsOnAtlassian
  } = useStatsig();
  const {
    cloudFortified,
    partner,
    programs,
    isRunsOnAtlassian
  } = transformedAppTrustData;
  const isAppCloudFortified = Boolean((cloudFortified === null || cloudFortified === void 0 ? void 0 : cloudFortified.isStatusApproved) && partner.name && partner.url);
  const isAppCloudSecurityParticipant = (programs === null || programs === void 0 ? void 0 : programs.bugBountyParticipant) && isBugBountyParticipant(AtlassianProductHostingType.Cloud, programs.bugBountyParticipant);
  const isRunsOnAtlassianEnabled = enableRunsOnAtlassian() && isRunsOnAtlassian;
  const contactPartnerLinkProps = getContactPartnerUrl(props);
  return /*#__PURE__*/_jsx(CustomerPrivacySecurityContextProvider, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(TabHeader, {
        isEmptyState: isEmptyState,
        contactPartnerLinkProps: contactPartnerLinkProps
      }), /*#__PURE__*/_jsxs(QnASectionWrapper, {
        children: [PrivacySecurityConfigV2.map(_ref3 => {
          let {
            heading,
            expandText,
            qna
          } = _ref3;
          return /*#__PURE__*/_jsx(QnASection, {
            heading: heading,
            qna: getQnAV2(qna, transformedAppTrustData),
            expandButton: {
              text: expandText,
              maxCount: 3
            }
          }, heading.text);
        }), (isRunsOnAtlassianEnabled || isAppCloudFortified || isAppCloudSecurityParticipant) && /*#__PURE__*/_jsx(Certification, {
          appName: appName,
          isRunsOnAtlassian: isRunsOnAtlassianEnabled,
          isAppCloudFortified: isAppCloudFortified,
          isAppCloudSecurityParticipant: isAppCloudSecurityParticipant,
          partnerName: (_partner$name = partner.name) !== null && _partner$name !== void 0 ? _partner$name : '',
          partnerUrl: (_partner$url = partner.url) !== null && _partner$url !== void 0 ? _partner$url : ''
        })]
      }), feedbackGatewayBaseUrl && feedbackCollectorApiKeys && /*#__PURE__*/_jsx(FeedbackCollectorWrapper, {
        feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
        feedbackCollectorApiKeys: feedbackCollectorApiKeys,
        userId: userId,
        contactPartnerLinkProps: contactPartnerLinkProps
      })]
    })
  });
};